module.exports = __webpack_public_path__ + "media/entities/2306-8abe3780.png";